import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import checkIcon from "../images/Icons/check.png"
import Credentials, { clientname, currentTenant, transactionFrom, userid } from "../Common/Credentials";
import MasterService from "../Masters/MasterService";
import DoneIcon from '@mui/icons-material/Done';
import CheckIcon from '@mui/icons-material/Check';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Grid, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import EastIcon from '@mui/icons-material/East';
import Swal from "sweetalert2";
import AuthenticationService from "../Authentication/AuthenticationService";

const InitialSetUp = () => {
const navigate = useNavigate();
const [configure,setConfigure]  = useState("") 
const [transactionstartdate,setTransactionstartdate] = useState(transactionFrom || new Date())
const [settingsStatus,setSettingsStatus] = useState({
    prefix:false,
    transactionFrom:transactionFrom,
    language:""
})
const [companydetails,setCompanydetails] = useState(false)

    useEffect(()=>{
        MasterService.retriveTenant(currentTenant).then((res)=>{
            if(res.data && res.data.clients && res.data.clients.zoneid && res.data.clients.fyenddate && res.data.clients.fystartdate ){
                setCompanydetails(true)
            }
            getTenantPrefixes()
    }).catch(()=>getTenantPrefixes())
        
    },[])

    const getTenantPrefixes = () =>{
        MasterService.getallprefixesofTenant(currentTenant).then(res=>{
            if(res.data && res.data.length>0){
                setSettingsStatus({...settingsStatus,prefix:true})
            }
        })
    }

    const handleConfigure = (val) =>{
        setConfigure(val)
    }

    const handleTransactionStartDateChange = (date) =>{
        setTransactionstartdate(date)
    }

    const SaveTransactionStartDate = ()=>{
        let data = {
            date:transactionstartdate,
            tenantid:currentTenant
          }
        MasterService.UpdateransactionStartDate(data).then((res)=>{
            setSettingsStatus({...settingsStatus,transactionFrom:transactionstartdate})
            Credentials.setTransactionFrom(transactionstartdate)
            handleConfigure(0)
        })
     }

     const handleContinue = () =>{
        MasterService.UpdateTenantInitialSetUpStatus(currentTenant).then((res)=>
            Swal.fire("",'Initial setup completed, please login again to redirect to actual application',"success").then(()=>navigate("/login"))
    )}

    const handleLogout = () =>{
        AuthenticationService.logout(userid).then((res)=>{
            navigate("/")
        })
    }

  return (
    <div>
       <Header InitialSetUp={true}/>
      {/*<Menu /> */}
      {/* <div className="content-wrapper"> */}
          <section className="content tw-px-5">
            <div className="container-fluid">
              <div className="row">
              <div className="col-12 tw-my-5">
                <h4 className="tw-font-semibold tw-text-xl">Welcome {clientname}!</h4>
                <p className="tw-my-1">Complete the initial setup to proceed with the application</p>
                </div>
                <div className="col-12">
                        <div className="tw-shadow-md tw-flex tw-justify-between tw-align-middle tw-p-10 tw-rounded-xl tw-bg-white tw-mb-2">
                            <div className="tw-flex tw-my-auto">
                                <div className="tw-my-auto tw-me-5">
                                <img src={checkIcon} className="tw-w-10"/>
                            </div>
                            <div>
                                <h4 className="tw-font-semibold tw-text-xl">Setup Transaction Start year</h4>
                                <p className="tw-my-1">Set up the year for your business transactions start from.</p>
                            </div>
                            </div>
                            {configure === 1?
                                <>
                                   <div className="tw-flex tw-my-auto">
                                   <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Grid container justifyContent="space-around">
                                        <DatePicker
                                            variant="standard"
                                            id="date-picker-dialog"
                                            // label="Transaction Start Date"
                                            maxDate={new Date()}
                                            minDate={moment("01-01-2000","DD-MM-YYYY")}
                                            value={transactionstartdate===null?new Date():transactionstartdate}
                                            onChange={handleTransactionStartDateChange}
                                            renderInput={(params) => <TextField {...params}  value={transactionstartdate} variant="standard" fullWidth size="small"/>}
                                            autoOk={true}
                                        />
                                        </Grid>
                                    </LocalizationProvider>
                                        <button className="btn btn-sm hovbuttonColour tw-ml-5" onClick={SaveTransactionStartDate}>Save</button>
                                    </div>   
                                </>:
                                settingsStatus.transactionFrom?
                                <div className="tw-flex tw-my-auto">
                                    <button className="btn btn-sm  Successbutton"> <TaskAltIcon fontSize="small" className="mr-1" color="action"/>Completed</button>
                                    </div>:
                            <div className="tw-flex tw-my-auto">
                                <button className="btn btn-sm hovbuttonColour" onClick={()=>handleConfigure(1)}>Configure</button>
                            </div>
                            }
                        </div>
                        
                        <div className="tw-shadow-md tw-flex tw-justify-between tw-align-middle tw-p-10 tw-rounded-xl tw-bg-white tw-mb-2">
                            <div className="tw-flex tw-my-auto">
                                <div className="tw-my-auto tw-me-5">
                                <img src={checkIcon} className="tw-w-10"/>
                            </div>
                            <div>
                                <h4 className="tw-font-semibold tw-text-xl">Company Details</h4>
                                <p className="tw-my-1">Set up your business details in accordance with the country’s legal requirements.</p>
                            </div>
                            </div>
                            <div className="tw-flex tw-my-auto">
                            {companydetails?
                                 <button className="btn btn-sm  Successbutton"> <TaskAltIcon fontSize="small" className="mr-1" color="action"/>Completed</button>:
                                <Link to="/clientdetails" state= {{ id: currentTenant, name: 'Update Tenant' }} className="btn btn-sm hovbuttonColour">Configure</Link>
                                }
                            </div>
                        </div>

                        <div className="tw-shadow-md tw-flex tw-justify-between tw-align-middle tw-p-10 tw-rounded-xl tw-bg-white tw-mb-2">
                            <div className="tw-flex tw-my-auto">
                                <div className="tw-my-auto tw-me-5">
                                <img src={checkIcon} className="tw-w-10"/>
                            </div>
                            <div>
                                <h4 className="tw-font-semibold tw-text-xl">Business settings</h4>
                                <p className="tw-my-1">Configure your invoice, purchase, sales order sequence as per your business requirements.</p>
                            </div>
                            </div>
                            <div className="tw-flex tw-my-auto">
                                {settingsStatus.prefix?
                                 <button className="btn btn-sm  Successbutton"> <TaskAltIcon fontSize="small" className="mr-1" color="action"/>Completed</button>:
                                <Link to="/prefixsettings" className="btn btn-sm hovbuttonColour">Configure</Link>
                                }
                            </div>
                        </div>

                        {/* <div className="tw-shadow-md tw-flex tw-justify-between tw-align-middle tw-p-10 tw-rounded-xl">
                            <div className="tw-flex tw-my-auto">
                                <div className="tw-my-auto tw-me-5">
                                <img src={checkIcon} className="tw-w-10"/>
                            </div>
                            <div>
                                <h4 className="tw-font-semibold tw-text-xl">Time Zone & Language Settings</h4>
                                <p className="tw-my-1">Set your timezone to match the region where your business is located and configure the necessary language settings.</p>
                            </div>
                            </div>
                            <div className="tw-flex tw-my-auto">
                            {configure === 4?
                                <>
                                   <div className="tw-flex tw-my-auto">
                                   <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Grid container justifyContent="space-around">
                                        <DatePicker
                                            variant="standard"
                                            id="date-picker-dialog"
                                            // label="Transaction Start Date"
                                            maxDate={new Date()}
                                            minDate={moment("01-01-2000","DD-MM-YYYY")}
                                            value={transactionstartdate===null?new Date():transactionstartdate}
                                            onChange={handleTransactionStartDateChange}
                                            renderInput={(params) => <TextField {...params}  value={transactionstartdate} variant="standard" fullWidth size="small"/>}
                                            autoOk={true}
                                        />
                                        </Grid>
                                    </LocalizationProvider>
                                        <button className="btn btn-sm hovbuttonColour tw-ml-5" onClick={SaveTransactionStartDate}>Save</button>
                                    </div>   
                                </>:
                                settingsStatus.transactionFrom?
                                <div className="tw-flex tw-my-auto">
                                    <button className="btn btn-sm  Successbutton"> <TaskAltIcon fontSize="small" className="mr-1"/>Completed</button>
                                    </div>:
                            <div className="tw-flex tw-my-auto">
                                <button className="btn btn-sm hovbuttonColour" onClick={()=>handleConfigure(4)}>Configure</button>
                            </div>
                            }
                            </div>
                        </div> */}
                        {
                            settingsStatus.prefix && settingsStatus.transactionFrom && companydetails &&
                            <div className="tw-my-4 tw-w-full tw-flex tw-justify-end tw-gap-1"> 
                            <button className="UI-btn UI-btn-outline" onClick={handleLogout}>Go back </button>
                            <button className="UI-btn UI-btn-primary" onClick={handleContinue}>Continue </button>
                            </div>

                        }

                </div>
              </div>
            </div>
          </section>
        {/* </div> */}
      {/* <Footer InitialSetUp={true}/> */}
    </div>
  );
};

export default InitialSetUp;
